import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import CustomersAppIphone from "../components/customers-app-iphone";
import styled from "styled-components";
import { Script } from "gatsby";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import { device } from "../components/utils/media";
import { SEO } from "../components/seo";
import { Paragraph } from "../components/typographie";
import { Grid, Row, Col } from "react-flexbox-grid";

const Background = styled.div<{ bg: string }>`
  position: relative;
  z-index: 20;
  min-height: 100vh;
  @media ${device.tablet} {
    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      width: 50%;
      height: 100%;
      background-color: ${(props) => props.bg};
    }
  }
`;

export const Zindex = styled.div`
  position: relative;
  z-index: 10;
`;

export const Icon = styled.div`
  margin-top: 20px;
  width: 110px;
  height: 110px;
  border: 1px solid #eee;
  border-radius: 20px;
  box-shadow: 0px 4.5px 6.5px 0 rgba(181, 197, 213, 0.3);
`;

export const AppInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media ${device.tablet} {
    height: 100vh;
  }
`;

export const AppTitle = styled.h1`
  font-size: 1.5rem;
  margin: 25px 0;
`;

export const MobileStore = styled.div`
  display: flex;
  align-items: center;
  a {
    padding: 0 10px;
    display: block;
  }
`;

export const ColMiddle = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Home = ({ ...props }) => {
  const data: Queries.ContentfulCustomersApp = props.data.contentfulCustomersApp;

  console.log(props);

  if (!data.appIcon?.url) return <Paragraph>No icon, please contact Robin.</Paragraph>;

  return (
    <Layout>
      <Script id="redirection">
        {`
          if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            location.replace("${data.appStoreLink}");
          } else if (/Android/i.test(navigator.userAgent)) {
            location.replace("${data.playStoreLink}");
          }
        `}
      </Script>
      <Background bg={data.backgroundColor!}>
        <Zindex>
          <Row middle="xs" style={{ minHeight: "100vh" }}>
            <ColMiddle xs={12} md={6}>
              <AppInfoContainer>
                <Icon>
                  {/* <GatsbyImage image={appIcon as any} imageUrl={data.appIcon.url} alt="" /> */}
                  {data && data.appIcon && data.appIcon.url && <img src={data.appIcon.url} className="img-responsive" alt="" />}
                </Icon>
                <AppTitle>{data.name}</AppTitle>
                {/* {data.name === "Cityscape Global Exhibition" && (
                  <div style={{ margin: "0 80px", textAlign: "center" }}>
                    Not registered yet? You will need to register for your free ticket to access the app{" "}
                    <a href="https://register.visitcloud.com/survey/1mjkhlnazmh5n?actioncode=WEB184&formType=Visitor%20Registration&formName=Visitor_Registration_Form">
                      Register Here
                    </a>
                  </div>
                )} */}

                <br />
                <br />
                {data.webappLink && (
                  <a href={data.webappLink}>
                    <StaticImage src={"../assets/images/customers-webapp-download.svg"} alt="" width={200} />
                  </a>
                )}
                <Paragraph style={{ margin: "10px 0" }}>or</Paragraph>
                <MobileStore>
                  {data.appStoreLink && (
                    <a href={data.appStoreLink}>
                      <StaticImage src={"../assets/images/app_store_1.jpg"} alt="" width={150} />
                    </a>
                  )}
                  {data.playStoreLink && (
                    <a href={data.playStoreLink}>
                      <StaticImage src={"../assets/images/play_store.jpg"} alt="" width={200} />
                    </a>
                  )}
                  {data.huaweiApkLinkSimple && (
                    <a href={data.huaweiApkLinkSimple}>
                      <StaticImage src={"../assets/images/huwai.png"} alt="" width={170} />
                    </a>
                  )}
                  {data.huaweiStoreLink && (
                    <a href={data.huaweiStoreLink}>
                      <StaticImage src={"../assets/images/app-huawei.png"} alt="" width={170} />
                    </a>
                  )}
                </MobileStore>
              </AppInfoContainer>
            </ColMiddle>
            <ColMiddle xs={12} md={6} style={{ minHeight: "100vh" }}>
              {data.screenshotIPhone?.url && <CustomersAppIphone url={data.screenshotIPhone.url} />}
            </ColMiddle>
          </Row>
        </Zindex>
      </Background>
    </Layout>
  );
};

export const Head = ({ ...props }) => {
  return <SEO title={props.pageContext.metaTitle} description={props.pageContext.metaDescription} />;
};

export const query = graphql`
  query CustomersApp($id: String!) {
    contentfulCustomersApp(id: { eq: $id }) {
      name
      screenshotIPhone {
        url
      }
      appIcon {
        url
      }
      webappLink
      appStoreLink
      playStoreLink
      backgroundColor
      huaweiApkLinkSimple
      huaweiStoreLink
    }
  }
`;

export default Home;
